import { useEffect, useState, useCallback } from "react";
import { PackageSearch } from "lucide-react";
import { rpc } from "@/lib/supabase";
import { PageHeader, EmptyState, Loader } from "@/components/kit";
import { ServiceCard } from "@/components/ServiceCard";

export default function BusinessServices() {
  const [list, setList] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(async () => {
    try {
      setList((await rpc("get_business_services", { p_only_active: true })) || []);
      setErr(null);
    } catch {
      setErr("No se pudieron cargar los servicios activos. Revisa tu conexión e intenta de nuevo.");
    }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  if (list === null && !err) return <Loader />;
  return (
    <div>
      <PageHeader title="Servicios activos" subtitle="Envíos en curso de tu negocio." testId="business-services" />
      {err ? (
        <div className="rounded-2xl border border-red-500/40 bg-red-500/10 p-6 text-center" data-testid="services-load-error">
          <p className="text-sm text-red-300">{err}</p>
          <button
            onClick={load}
            data-testid="services-retry-button"
            className="mt-3 rounded-xl bg-[#FF6A00] px-5 py-2.5 text-sm font-extrabold text-black transition-transform active:scale-95"
          >
            Reintentar
          </button>
        </div>
      ) : list.length === 0 ? (
        <EmptyState icon={PackageSearch} title="Sin servicios activos" subtitle="Cuando solicites un envío aparecerá aquí." testId="empty-services" />
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {list.map((s) => (
            <ServiceCard key={s.id} s={s} to={`/business/service/${s.id}`} testId={`service-${s.id}`} />
          ))}
        </div>
      )}
    </div>
  );
}
